export const ANIMATION_DURATION = 200; // Duration in ms
